(function () {
    const animatedImageCollage = () => {
        const items = document.querySelectorAll(".animated-image-collage_grid");
        const isMobile = window.innerWidth < 768;
        const duration = isMobile ? 8 : 20;
        
        gsap.fromTo(
            items,  
            { x: "10vw" },  
            { x: "-200vw", duration: duration, repeat: -1, ease: "linear" } 
        );
    };
    
    document.addEventListener("DOMContentLoaded", function () {
        animatedImageCollage();
        document.addEventListener("shopify:section:load", function () {
            animatedImageCollage();
        });
    });
})();
